import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ENVIRONMENT } from '@cfp/core';
import { OauthSsoAuthorizationUrlResponseDTO, OauthSsoLoginService } from 'csr-login-app';
import { SsoOauthStateService } from '../../pages/sso-oauth-authentication';
import { ExternalNavigationService } from '../../services';

@Component({
  selector: 'cfp-sso-auth-path',
  template: ''
})
export class SsoAuthPathPage implements OnInit {
  private readonly environment = inject(ENVIRONMENT);
  private readonly oauthSsoLoginService = inject(OauthSsoLoginService);
  private readonly externalNavigationService = inject(ExternalNavigationService);
  private readonly router = inject(Router);
  private readonly ssoOauthStateService = inject(SsoOauthStateService);

  public ngOnInit(): void {
    this.oauthSsoLoginService
      .oauthSsoAuthorizationUrlEnvironmentCodeGet(this.environment.environmentCode.path)
      .subscribe({
        next: (response: OauthSsoAuthorizationUrlResponseDTO) => {
          const url: URL = new URL(response.authorizationUrl);
          const state = url.searchParams.get('state');
          if (state) {
            this.ssoOauthStateService.storeState(state);
          }
          this.externalNavigationService.navigateTo(response.authorizationUrl);
        },
        error: () => {
          this.router.navigate(['/']);
        }
      });
  }
}
